'use strict';
import React, {Component} from 'react';
import createClass from 'create-react-class';

export default createClass({
   backgroundColour(colour){
       switch(colour){
           case -1:
                return "rgba(0,0,0,0)";
           case 0:
               return "#e9e9e9";
           case 1:
               return "#D0021B";
           case 2:
               return "#7ED321";
           case 3:
               return "#4A90E2";
           case 4:
               return "#F5A623";
           case 5:
               return "#F8E71C";
           case 6:
               return "#BD10E0";
       }
   },
   render(){
       const {x, y, delta} = this.props;
       const margin = delta/12;

       if(this.props.item.interactive){
           return (
               <rect fill={this.backgroundColour(this.props.item.colour)}
                     onClick={this.props.onClick}
                     x={x * delta + margin}
                     y={y * delta + margin}
                     height={delta - 2 * margin}
                     width={delta - 2 * margin}
                     rx={1}
                     ry={1}
               />
            );
       } else {
           return <rect fill={this.backgroundColour(this.props.item.colour)}
                        x={x * delta + margin}
                        y={y * delta + margin}
                        height={delta - 2 * margin}
                        width={delta - 2 * margin}
                        rx={1}
                        ry={1}
                        opacity={0.5} />
       }
   }
});


// WEBPACK FOOTER //
// ./src/components/rgb/components/game/GridItem.js